import { cn } from "@/shared/lib/cn";
import { CardMenu } from "@/shared/ui/CardMenu";

type DashboardCardProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
  showMenu?: boolean;
};

export function DashboardCard({
  title,
  children,
  className,
  showMenu = true,
}: DashboardCardProps) {
  return (
    <div className={cn("theme-card p-5", className)}>
      <div className="flex items-start justify-between gap-3">
        <p className="text-sm font-semibold text-foreground">{title}</p>
        {showMenu ? <CardMenu /> : null}
      </div>
      <div className="mt-4">{children}</div>
    </div>
  );
}
